export const timeoutConfig = {
  timeoutMs: Number(import.meta.env.VITE_APP_TIMEOUT || 900) * 1000, // 15 min default
  warningMs: Number(import.meta.env.VITE_APP_TIMEOUT_WARNING || 60) * 1000, // 1 min default
  get timeoutSeconds() {
    return Math.max(1, Math.floor(this.timeoutMs / 1000));
  },
  get warningSeconds() {
    return Math.max(1, Math.floor(this.warningMs / 1000));
  },
  get idleThresholdMs() {
    return this.timeoutMs - this.warningMs;
  }
};